import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import './new-ocurrence.css'
import firebase from '../../config/firebase';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import PersistentDrawerLeft from "../../components/navMenu/NavMenu";
import '../../view/frete/freight.css'
import { Input, Typography, Switch, Form, Card, Space, Button, Layout, Breadcrumb } from 'antd';
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { GlobalSuccessModal, GlobalWarningGlobal, GlobalRequiredFieldsModal } from "../../components/modalGlobal/modalGlobal";
require('firebase/auth')

function NewOcurrence(){

    const db = firebase.firestore();

    const { Title, Text } = Typography;
    const { Header, Content, Footer } = Layout;

    const location = useLocation();

    const {id} = useParams();

    let navigate = useNavigate();

    const [view, setOnlyView] = useState(location.state?.viewOnly);
    
    const [name, setName] = useState();
    const [isComent, setIsComent] = useState();
    const [isPhoto, setIsPhoto] = useState();
    const [isApplication, setIsApplication] = useState();
    const [isClient, setIsClient] = useState();

    const [carregando, setCarregando] = useState(1);

    const [openWarning, setOpenWarning] = useState(false);
    const [warningTitle, setWarningTitle] = useState("");
    const [warningMsg, setWarningMsg] = useState("");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successModalTitle, setSuccessModalTitle] = useState("");
    const [showRequiredFieldsModal, setShowRequiredFieldsModal] = useState(false);
    const [requiredFieldsMessages, setRequiredFieldsMessages] = useState([]);

    const user = useSelector(state => state.user)


    useEffect(() => {
        if (!id) return;
        db.collection('ocurrence').doc(id)
        .get().then( async (result) => {
            
            var data = result.data();
                

            if(id && data){
                
                setName(data.name)
                setIsApplication(data.isApplication)
                setIsClient(data.isClient)
                setIsComent(data.isComent)
                setIsPhoto(data.isPhoto)

            }

        }).catch(error => {
            setCarregando(0)
            console.log(error)
        });
            
    },[id]);
        


    function validateRequiredFields() {
        const missing = [];
        if (!name || !String(name).trim()) {
            missing.push("Nome é obrigatório.");
        }
        if (missing.length > 0) {
            setRequiredFieldsMessages(missing);
            setShowRequiredFieldsModal(true);
            setCarregando(0);
            return false;
        }
        return true;
    }

    function save(){
        if (!validateRequiredFields()) return;

        setCarregando(1);

        var data = {
            name: name,
            isClient:  isClient ? isClient : false,
            isApplication: isApplication ? isApplication : false,
            isComent: isComent ? isComent : false,
            isPhoto: isPhoto ? isPhoto : false,
        }

        firebase.firestore().collection('ocurrence').add(data).then(() => {
            setSuccessModalTitle("Ocorrência cadastrada com sucesso!");
            setShowSuccessModal(true);
        }).catch(error => {
            setWarningTitle("Erro ao Salvar");
            setWarningMsg("Houve um problema ao salvar a Ocorrência!");
            setOpenWarning(true);
        }).finally(()=>{
            setCarregando(0);
        });
    }

    function update(){
        if (!validateRequiredFields()) return;

        setCarregando(1);

        var data = {
            name: name,
            isClient:  isClient ? isClient : false,
            isApplication: isApplication ? isApplication : false,
            isComent: isComent ? isComent : false,
            isPhoto: isPhoto ? isPhoto : false,
        }

        db.collection("ocurrence").doc(id).update(data).then(() => {
            setSuccessModalTitle("Ocorrência atualizada com sucesso!");
            setShowSuccessModal(true);
        }).catch(error => {
            setWarningTitle("Erro ao Salvar");
            setWarningMsg("Houve um problema ao salvar a Ocorrência!");
            setOpenWarning(true);
        }).finally(()=>{
            setCarregando(0);
        });
    }

    return(
        <>
            <NewMiniDrawer divOpen={ 
                
                <Layout  style={{
                            padding: 0,
                            background: '#FFFF'
                        }}>
                        <Header
                            style={{
                                padding: 0,
                                background: '#FFFF'
                            }}
                        >
                            <Title level={3} style={{ textAlign: 'left', color: '#333' }}>Cadastro de Ocorrências</Title>
                        </Header>

                        <GlobalWarningGlobal
                            open={openWarning}
                            handleClose={() => setOpenWarning(false)}
                            title={warningTitle}
                            subtitle={warningMsg}
                        />

                        <GlobalSuccessModal
                            open={showSuccessModal}
                            handleClose={() => {
                                setShowSuccessModal(false);
                                navigate("/listOcurrence");
                            }}
                            title={successModalTitle}
                        />
                        <GlobalRequiredFieldsModal
                            open={showRequiredFieldsModal}
                            handleClose={() => setShowRequiredFieldsModal(false)}
                            messages={requiredFieldsMessages}
                        />
                        
                        <Content
                        style={{
                            margin: '0 16px',
                        }}
                        >
                        <Breadcrumb
                            style={{
                            margin: '16px 0',
                            }}
                        >
                            <Breadcrumb.Item>Home</Breadcrumb.Item>
                            <Breadcrumb.Item>Ocorrências</Breadcrumb.Item>
                        </Breadcrumb>
                        <div
                            style={{
                            padding: 24,
                            minHeight: 360,
                            background: '',
                            borderRadius: '',
                            }}
                        >

                            <Card style={{  display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                
                                {/* <Title level={3} style={{ textAlign: 'center', color: '#333' }}>Cadastro de Ocorrências</Title> */}
                    
                                    <Input
                                        disabled={view}
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                        placeholder="Digite o nome"
                                        style={{ borderRadius: '8px', height: '40px', fontSize: '16px' }}
                                    />
                    
                                    <div style={{ margin: '20px 0' }}>
                                        <Text strong style={{ fontSize: '16px', color: '#333' }}>Opções de Visibilidade</Text>
                                        <Space direction="vertical" size="large" style={{ width: '100%', marginTop: '10px' }}>
                                            <Form.Item>
                                                <Space align="center">
                                                    <Switch disabled={view} checked={isClient} onChange={setIsClient} />
                                                    <span>Visível para o cliente</span>
                                                </Space>
                                            </Form.Item>

                                            <Form.Item>
                                                <Space align="center">
                                                    <Switch disabled={view} checked={isApplication} onChange={setIsApplication} />
                                                    <span>Visível para o aplicativo</span>
                                                </Space>
                                            </Form.Item>

                                            <Form.Item>
                                                <Space align="center">
                                                    <Switch disabled={view} checked={isPhoto} onChange={setIsPhoto} />
                                                    <span>Exigir foto</span>
                                                </Space>
                                            </Form.Item>

                                            <Form.Item>
                                                <Space align="center">
                                                    <Switch disabled={view} checked={isComent} onChange={setIsComent} />
                                                    <span>Exibir comentário</span>
                                                </Space>
                                            </Form.Item>
                                        </Space>
                                    </div>

                                        <Button disabled={view} type="primary" size="large" onClick={id ? update : save } style={{ borderRadius: '8px', width: '100%' }}>
                                            Salvar
                                        </Button>
                            </Card>

                        </div>
                        </Content>
                        <Footer
                        style={{
                                textAlign: 'center',
                                padding: 0,
                                background: '#FFFF'
                            }}
                            >

                        </Footer>
                </Layout>



            // <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '20px' }}>
            //     <Card style={{ width: '100%', maxWidth: '600px', padding: '20px' }}>
                    
            //         <Title level={3} style={{ textAlign: 'center', color: '#333' }}>Cadastro de Ocorrências</Title>
        
            //                 <Input
            //                     value={name}
            //                     onChange={(e) => setName(e.target.value)}
            //                     placeholder="Digite o nome"
            //                     style={{ borderRadius: '8px', height: '40px', fontSize: '16px' }}
            //                 />
        
            //             <div style={{ margin: '20px 0' }}>
            //                 <Text strong style={{ fontSize: '16px', color: '#333' }}>Opções de Visibilidade</Text>
            //                 <Space direction="vertical" size="large" style={{ width: '100%', marginTop: '10px' }}>
            //                     <Form.Item>
            //                         <Space align="center">
            //                             <Switch checked={isClient} onChange={setIsClient} />
            //                             <span>Visível para o cliente</span>
            //                         </Space>
            //                     </Form.Item>

            //                     <Form.Item>
            //                         <Space align="center">
            //                             <Switch checked={isApplication} onChange={setIsApplication} />
            //                             <span>Visível para o aplicativo</span>
            //                         </Space>
            //                     </Form.Item>

            //                     <Form.Item>
            //                         <Space align="center">
            //                             <Switch checked={isPhoto} onChange={setIsPhoto} />
            //                             <span>Exigir foto</span>
            //                         </Space>
            //                     </Form.Item>

            //                     <Form.Item>
            //                         <Space align="center">
            //                             <Switch checked={isComent} onChange={setIsComent} />
            //                             <span>Exibir comentário</span>
            //                         </Space>
            //                     </Form.Item>
            //                 </Space>
            //             </div>

            //                 <Button type="primary" size="large" style={{ borderRadius: '8px', width: '100%' }}>
            //                     Salvar
            //                 </Button>
            //     </Card>
            // </div>
            }/>
        </>
    )
}

export default NewOcurrence;